<template>
  <button
    :type="type"
    :disabled="isDisabled"
    class="filled-button"
    v-bind="$attrs"
  >
    <TheSpinner v-if="isLoading"/>
    <slot />
  </button>
</template>

<script>
import TheSpinner from '@/components/TheSpinner.vue'

export default {
  name: 'FilledButton',

  components: { TheSpinner },

  props: {
    type: {
      type: String,
      default: 'button'
    },

    isLoading: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isDisabled() {
      return this.isLoading || this.disabled
    }
  }
}
</script>

<style scoped lang="scss">
.filled-button {
  display: inline-flex;
  padding: 15px 25px;
  align-items: center;
  justify-content: center;
  background: #9A2B0B;
  transition: background 0.3s;
  font-size: 18px;
  border-radius: 12px;
  color: #ffffff;

  &:hover:not(:disabled) {
    background: #8b270a;
  }

  &:disabled {
    background: #efeff0;
    color: #bbbcbf;
    cursor: auto;
  }
}
</style>
